import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";

import { Invocations } from "../../containers/Wizard";
import { CAPTION_PATH, DURATION_SELECTION_PATH } from "../../routing/paths";
import FillOrigamiSchedulingStep from "../FillOrigamiSchedulingStep";
import { Widget } from "../../containers/WidgetSelectionStep/actions";

const WIDGET_SPELL_NAME = "widget";

const FillOrigamiSchedulingStepProps = {
  previous: CAPTION_PATH,
  next: DURATION_SELECTION_PATH,
  question: "Where in our website do you want to promote your brand",
  description: "Choose an option below to proceed.",
  spellName: WIDGET_SPELL_NAME,
  required: true,
  showExpanded: false,
};

export type WidgetSelectionStepProps = {
  loading?: boolean;
  widgets: Array<Widget>;
  invocate: Function;
  getWidgets: Function;
  invocations: Invocations;
  changePath: Function;
};

export const WidgetSelectionStep: FunctionComponent<WidgetSelectionStepProps> = ({
  loading,
  widgets,
  invocate,
  getWidgets,
  invocations,
  changePath,
}: WidgetSelectionStepProps) => {
  return (
    <FillOrigamiSchedulingStep
      invocations={invocations}
      loading={loading}
      options={widgets}
      invocate={invocate}
      getWidgets={getWidgets}
      changePath={changePath}
      {...FillOrigamiSchedulingStepProps}
    />
  );
};

WidgetSelectionStep.propTypes = {
  loading: PropTypes.bool.isRequired,
  widgets: PropTypes.array.isRequired,
  invocate: PropTypes.func.isRequired,
  getWidgets: PropTypes.func.isRequired,
  invocations: PropTypes.any,
};

export default WidgetSelectionStep;
